import { SubscriptionProductModel } from "dash-common";
import { Flex, Form, Select, Text, ViewerContext } from "dash-ui";
import { RoutesPath } from "flow-components/routes/routes";
import { useGetSubscriptionProductsQuery } from "gql/generated.graphql";
import camelCase from "lodash/camelCase";
import { useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import styled, { useTheme } from "styled-components";

const LinkStyle = styled(Link)`
  margin-top: 3px;
  margin-left: 4px;
`;

function SubscriptionsCard({
  activeSubscription,
  onSubscriptionChange,
}: {
  activeSubscription?: SubscriptionProductModel | null;
  onSubscriptionChange: (subscription: SubscriptionProductModel) => void;
}) {
  const { t } = useTranslation(["pages", "common"]);
  const { userHasTrialed } = useContext(ViewerContext);
  const { subscriptionId } = useParams();
  const theme = useTheme();
  const { data, loading } = useGetSubscriptionProductsQuery({});
  // FIXME: re-check next line
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const subscriptions = data?.getSubscriptionProducts || [];
  const preselectedSub = useMemo(
    () => subscriptions.find(({ _id }) => _id === subscriptionId),
    [subscriptions, subscriptionId]
  );

  useEffect(() => {
    if (preselectedSub) {
      onSubscriptionChange(preselectedSub as SubscriptionProductModel);
    }
  }, [preselectedSub, onSubscriptionChange]);

  return (
    <Flex w="100%" flexDirection="column">
      <Flex>
        <Text bold xl>
          {t("pages:completeSignUpAddPaymentPage:subscriptionSubHeader")}
        </Text>
      </Flex>
      <Flex mt={2} w="100%">
        <Form.Group w="100%">
          <Form.Label xs color={theme.colors.n80}>
            {t("pages:completeSignUpAddPaymentPage:subscriptionSelectLabel")}
          </Form.Label>
          <Select
            w="100%"
            value={activeSubscription?._id || preselectedSub?._id || ""}
            isLoading={loading}
            onChanged={(value: string) => {
              onSubscriptionChange(
                subscriptions.find(
                  ({ _id }) => _id === value
                ) as SubscriptionProductModel
              );
            }}
            options={subscriptions.map((subscription) => ({
              label: `${t(
                `pages:completeSignUpPickSubscription:subscriptionProductRecurringLabels:${camelCase(
                  subscription.recurringType
                )}`
              )} - ${subscription.name} $${subscription.price}`,
              value: subscription._id,
            }))}
          />
        </Form.Group>
      </Flex>
      <Flex flexDirection="column" mt={4}>
        <Flex>
          <Text>
            {t("pages:completeSignUpAddPaymentPage:subscriptionInfoLabel2")}
            <LinkStyle target="_blank" to={RoutesPath.TermConditions}>
              {t("pages:brokerSignUpPage:termsAndConditionsLabel2")}
            </LinkStyle>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default SubscriptionsCard;
